import { render, staticRenderFns } from "./ModalDoesntHaveBirth.vue?vue&type=template&id=6a548bd3&scoped=true&"
import script from "./ModalDoesntHaveBirth.vue?vue&type=script&lang=js&"
export * from "./ModalDoesntHaveBirth.vue?vue&type=script&lang=js&"
import style0 from "./ModalDoesntHaveBirth.vue?vue&type=style&index=0&id=6a548bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a548bd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VDivider})
